<script>
  import { onMount } from 'svelte';
  import { _ } from 'svelte-intl';
  import formatAnnotation from '../../helpers/formatAnnotation';

  export let annotation; // string

  let moreShown = false;
  let annotationExpanded = false;
  let annotationElement;

  function expandAnnotation() {
    annotationExpanded = true;
  }

  onMount(() => {
    if (annotationElement.offsetHeight < annotationElement.scrollHeight) {
      moreShown = true;
    }
  });
</script>

<style lang="stylus">
  .expandable
    text-align: left
    margin: 30px 0 24px

    &.collapsed .more
      display: inline

    &.expanded .annotation
      overflow: visible
      display: block

    &.expanded .more
      display: none

  .annotation
    $line-clamp(5)
    text-align: left
    font-size: 18px
    color: $warm-grey
    word-wrap: break-word
    word-break: @word-wrap
    hyphens: auto

  .annotation :global(*)
    display: inline-block
    font-size: inherit
    font-weight: inherit
    font-style: inherit

  .annotation :global(h1),
  .annotation :global(h2),
  .annotation :global(h3),
  .annotation :global(h4),
  .annotation :global(h5),
  .annotation :global(h6),
  .annotation :global(blockquote)
    display: block

  .annotation :global(blockquote),
  .annotation :global(ul),
  .annotation :global(ol)
    margin: 0

  .annotation :global(ul),
  .annotation :global(ol)
    padding: 0

  .annotation :global(li)
    display: list-item
    margin-bottom: 16px

  .annotation :global(ul li)
    list-style: none
    padding-left: 1em

  .annotation :global(ul li::before)
    content: '– '
    display: inline-block
    margin-left: -1em

  .more
    display: none
    cursor: pointer
    color: #c1c1c1

    @media $bp.desktop
      &:hover
        color: $violet
</style>

<div
class="expandable"
class:collapsed={moreShown}
class:expanded={annotationExpanded}
>
  <div class="annotation" bind:this={annotationElement}>
    {@html formatAnnotation(annotation)}
  </div>
  <span class="more" on:click={expandAnnotation}>{$_('more')}</span>
</div>
